import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "intersport-product-modal",
  tabindex: "-1",
  "aria-labelledby": "intersport-product-modal",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "intersport-product-modal"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-no-styling btn-close",
  "aria-label": "Close",
  "data-bs-dismiss": "modal"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" })
], -1)
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "intersport-product-modal__product" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "intersport-product-modal__product-info" }
const _hoisted_11 = { class: "interpsort-product__prices" }
const _hoisted_12 = {
  key: 0,
  class: "interpsort-product__price"
}
const _hoisted_13 = { class: "interpsort-product__price-tag" }
const _hoisted_14 = {
  key: 1,
  class: "interpsort-product__price"
}
const _hoisted_15 = { class: "interpsort-product__price-tag" }
const _hoisted_16 = {
  key: 0,
  class: "intersport-product__economy-badge"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-leaf" }, null, -1)
const _hoisted_18 = { class: "h5 text-secondary mb-4 mb-md-0 mt-4 mt-md-5" }
const _hoisted_19 = { class: "list-unstyled" }
const _hoisted_20 = {
  id: "add-person-collapse",
  class: "collapse"
}
const _hoisted_21 = { class: "row gy-2" }
const _hoisted_22 = {
  key: 0,
  class: "col-12 col-md-6"
}
const _hoisted_23 = { class: "col-12 col-md-6" }
const _hoisted_24 = { class: "col-12 col-md-6" }
const _hoisted_25 = { class: "d-flex flex-column flex-md-row gap-2 justify-content-between mt-3 mt-md-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close btn-icon-text__icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_27 = { class: "d-flex gap-2 order-1 ordre-md-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-check btn-icon-text__icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-check btn-icon-text__icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-accordeon-open btn-icon-text__icon" }, null, -1)
const _hoisted_31 = { class: "intersport-prodcut-modal__total-price" }
const _hoisted_32 = { class: "intersport-prodcut-modal__total-price-tag" }
const _hoisted_33 = { class: "modal-footer" }
const _hoisted_34 = {
  type: "button",
  class: "btn btn-secondary btn-outline btn-icon-text order-2 order-md-1",
  "data-bs-dismiss": "modal"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close btn-icon-text__icon",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_36 = ["disabled"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-check btn-icon-text__icon",
  "aria-hidden": "true"
}, null, -1)

import { computed, onMounted, onUpdated, ref, nextTick, watch } from "vue";
// @ts-ignore
import { translate } from "@elements/translations";
// @ts-ignore
import * as formValidation from "@elements/form-validation";
// @ts-ignore
import {deepCopy, reassignFormValidationField} from "../utils/utils.ts";
// @ts-ignore
import {AdditionalData, Person, Availability} from "../types/intersport.ts";
import { usePeopleStore } from "../stores/PeopleStore.ts";
import { useProductsStore } from "../stores/ProductStore.ts";
import { useSearchStore } from "../stores/SearchStore.ts";
import Price from "./components/Price.vue";
import IntersportProductModalPerson from "./components/IntersportProductModalPerson.vue";
import Datepicker from "./components/form-elements/Datepicker.vue";
import FormControl from "./components/form-elements/FormControl.vue";
import CustomSelect from "./components/form-elements/CustomSelect.vue";
import LoadingSpinner from "./components/LoadingSpinner.vue";

const newPersonBirthDateName = 'new-person-birthDate';


export default /*#__PURE__*/_defineComponent({
  __name: 'IntersportProductModal',
  setup(__props) {

// @ts-ignore
const peopleStore = usePeopleStore();
const productsStore = useProductsStore();
const searchStore = useSearchStore();
const addPersonForm = ref<HTMLFormElement>();
const newPersonBirthDate = ref<HTMLElement>();

const selectablePeople = computed(() => {
  return peopleStore.getSelectablePeople()
});

const addPersonClass = computed(() => {
  const staticClasses = 'btn btn-nostyling btn-icon-text intersport-product-modal__add-person-btn js-toggle-add-person-collapse';
  return staticClasses + (Object.keys(peopleStore.editPerson).length === 0 || peopleStore.editPerson.id !== '' ? '' : ' d-none');
});

const adultPricing = computed(() => {
  return productsStore.getOpenProductPricing(true);
});

const kidPricing = computed(() => {
  return productsStore.getOpenProductPricing(false);
});

const peopleList = computed(() => {
  let tmpList: Person[] = [];

  if (Object.keys(productsStore.openProduct).length > 0) {
    productsStore.openProduct.availabilities.forEach((availability: Availability) => {
      tmpList.push({...peopleStore.getPersonInfo(availability.personId), ...availability});
    });
  }

  return tmpList;
});

const missingAdditionalData = computed(() => {
  let ids: string[] = [];
  let inputs: AdditionalData[] = [];

  ids = productsStore.openProduct.relevantAdditionalData || [];

  peopleStore.additionalData.forEach((item: AdditionalData) => {
    if (ids.includes(item.id)) {
      inputs.push(deepCopy(item));
    }
  })

  return inputs;
});

function isLastPerson (max, index) {
  return max === index;
}

function changeSelectedPerson(e: string, isFirstUpdate: boolean) {
  if (!isFirstUpdate) {
    peopleStore.selectPersonFromAccount(e);
  }
}

function filterConflicts(conflicts: string[]) {
  if (conflicts) {
    const tmpArray = conflicts.filter((conflict: string) => conflict !== productsStore.openProduct.id);
    return tmpArray.length > 0 ? tmpArray : null;
  }

  return null;
}

watch(newPersonBirthDate, (newValue: HTMLElement) => {
  if (newValue) {
    reassignFormValidationField(addPersonForm.value, newPersonBirthDateName + 'input');
  }
}, {deep: true});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(peopleStore).loading)
          ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(productsStore).openProduct.title), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_7, [
            (_unref(peopleStore).loadingObject.loading)
              ? (_openBlock(), _createBlock(LoadingSpinner, { key: 0 }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                class: "ratio ratio-16x9",
                innerHTML: _unref(productsStore).openProduct.modalImgHtml
              }, null, 8, _hoisted_9),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  (adultPricing.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(translate)('intersport.adult-price-text')), 1),
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(_unref(translate)('intersport.price-from-text')) + " ", 1),
                          _createVNode(Price, {
                            value: adultPricing.value.price
                          }, null, 8, ["value"])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (kidPricing.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(translate)('intersport.kid-price-text')), 1),
                        _createElementVNode("span", null, [
                          _createTextVNode(_toDisplayString(_unref(translate)('intersport.price-from-text')) + " ", 1),
                          _createVNode(Price, {
                            value: kidPricing.value.price
                          }, null, 8, ["value"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_unref(productsStore).openProduct.isEconomyProduct)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createTextVNode(" " + _toDisplayString(_unref(translate)('intersport.economy-badge-text')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("h6", _hoisted_18, _toDisplayString(_unref(translate)('intersport.choose-people-for-product-text')), 1),
            _createElementVNode("ul", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(peopleList.value, (person, key) => {
                return (_openBlock(), _createBlock(IntersportProductModalPerson, {
                  id: person.id,
                  firstName: person.firstName,
                  lastName: person.lastName,
                  birthDate: person.birthDate,
                  pricing: person.pricing,
                  additionalData: person.additionalData,
                  conflicts: filterConflicts(person.conflicts),
                  selected: person.selected,
                  relevantAdditionalData: _unref(productsStore).openProduct.relevantAdditionalData,
                  isLastPerson: isLastPerson(peopleList.value.length - 1, key)
                }, null, 8, ["id", "firstName", "lastName", "birthDate", "pricing", "additionalData", "conflicts", "selected", "relevantAdditionalData", "isLastPerson"]))
              }), 256)),
              _createElementVNode("li", null, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("form", {
                    class: "intersport-product-modal__add-person js-form-validation",
                    ref_key: "addPersonForm",
                    ref: addPersonForm
                  }, [
                    _createElementVNode("div", _hoisted_21, [
                      (selectablePeople.value.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode(CustomSelect, {
                              id: "people-select",
                              name: "people-select",
                              "class-name": "form-group--bold",
                              label: _unref(translate)('intersport.select-person-label'),
                              options: selectablePeople.value,
                              onChangeValue: _cache[0] || (_cache[0] = (event, isFirstUpdate) => changeSelectedPerson(event, isFirstUpdate))
                            }, null, 8, ["label", "options"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_23, [
                        (_openBlock(), _createBlock(Datepicker, {
                          "class-name": "form-group--bold",
                          "min-date": "1900-01-01T00:00:00",
                          "max-date": "today",
                          label: _unref(translate)('intersport.pick-birth-date-label'),
                          id: newPersonBirthDateName,
                          name: newPersonBirthDateName,
                          placeholder: _unref(translate)('intersport.pick-birth-date-placeholder'),
                          required: true,
                          key: [_unref(peopleStore).editPerson.birthDate].toString(),
                          "model-value": _unref(peopleStore).editPerson.birthDate,
                          modelValue: _unref(peopleStore).editPerson.birthDate,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(peopleStore).editPerson.birthDate) = $event)),
                          ref_key: "newPersonBirthDate",
                          ref: newPersonBirthDate
                        }, null, 8, ["label", "placeholder", "model-value", "modelValue"]))
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(missingAdditionalData.value, (input) => {
                        return (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createVNode(FormControl, {
                            id: 'new-person_' + input.id,
                            name: 'new-person_' + input.id,
                            type: input.type,
                            placeholder: input.placeholder,
                            label: input.label,
                            required: true,
                            value: _unref(peopleStore).getEditPersonAdditionalDataValue(input.id),
                            "onUpdate:modelValue": ($event: any) => (_unref(peopleStore).changeEditPersonValue('additionalData', $event, input.id))
                          }, null, 8, ["id", "name", "type", "placeholder", "label", "value", "onUpdate:modelValue"])
                        ]))
                      }), 256))
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-secondary btn-outline btn-icon-text order-2 order-md-1",
                        "data-bs-toggle": "collapse",
                        "data-bs-target": "#add-person-collapse",
                        "aria-expanded": "false",
                        "aria-controls": "#add-person-collapse",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(peopleStore).toggleAddPersonCollapse(_unref(productsStore).openProduct.relevantAdditionalData)))
                      }, [
                        _hoisted_26,
                        _createTextVNode(" " + _toDisplayString(_unref(translate)('intersport.modal-cancel')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_27, [
                        (_unref(peopleStore).profileRequestUrl)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "btn btn-green btn-outline btn-icon-text order-1 order-md-2",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(peopleStore).addNewPersonFromProductModal(addPersonForm.value, true)))
                            }, [
                              _hoisted_28,
                              _createTextVNode(" " + _toDisplayString(_unref(translate)('intersport.save-to-profile')), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-green btn-icon-text order-1 order-md-2",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(peopleStore).addNewPersonFromProductModal(addPersonForm.value)))
                        }, [
                          _hoisted_29,
                          _createTextVNode(" " + _toDisplayString(_unref(translate)('intersport.modal-save')), 1)
                        ])
                      ])
                    ])
                  ], 512)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": "#add-person-collapse",
                  "aria-expanded": "false",
                  "aria-controls": "#add-person-collapse",
                  class: _normalizeClass(addPersonClass.value),
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(peopleStore).toggleAddPersonCollapse(_unref(productsStore).openProduct.relevantAdditionalData)))
                }, [
                  _hoisted_30,
                  _createElementVNode("span", null, _toDisplayString(_unref(translate)('intersport.sidebox-add-person')), 1)
                ], 2)
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(translate)('intersport.modal-total-price-tag')), 1),
              _createElementVNode("strong", null, [
                _createVNode(Price, {
                  value: _unref(productsStore).getOpenProductTotalPrice()
                }, null, 8, ["value"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", _hoisted_34, [
              _hoisted_35,
              _createTextVNode(" " + _toDisplayString(_unref(translate)('intersport.modal-cancel')), 1)
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-green btn-icon-text order-1 order-md-2",
              disabled: _unref(productsStore).getOpenProductSelectedAvailabilities().length === 0,
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_unref(productsStore).saveSelectedAvailabilitiesForProduct()))
            }, [
              _hoisted_37,
              _createTextVNode(" " + _toDisplayString(_unref(translate)('intersport.modal-save')), 1)
            ], 8, _hoisted_36)
          ])
        ])
      ])
    ])
  ]))
}
}

})